import { IMenu, MenuGroupInfoType } from 'apis/types';
import { MENU_TIMING_STATUS } from 'constants/menuTiming';
import { DisplayTimingGroupResults, resolveMenuTimingStatus } from 'utils/displayTimingGroup';

/**
 * Single source of truth for "will this menu slot produce a DOM node?".
 * Mirrors the render conditions of SubGenreMenu so that genre/subgenre visibility
 * never disagrees with what is actually painted.
 */
export function isMenuSlotRendered(
  menuSlot: MenuGroupInfoType,
  menuData?: IMenu,
  shinagire: string[] = [],
  displayTimingGroupResults: DisplayTimingGroupResults = {}
): boolean {
  // Menu master not loaded yet: stay optimistic so navigation does not collapse while booting.
  if (!menuData) return true;

  const menuItemInfo = menuData[menuSlot.poscd];
  // A poscd without a master record is skipped by the renderer.
  if (!menuItemInfo) return false;

  const isTimingHidden = resolveMenuTimingStatus(menuItemInfo, displayTimingGroupResults) === MENU_TIMING_STATUS.HIDDEN;
  // Matches the EOS_MESSAGE branch of getErrorMessage, which hides the item in SubGenreMenu.
  const isEosHidden = menuItemInfo.eos_flg === '1' && shinagire.includes(menuSlot.poscd);

  return !isTimingHidden && !isEosHidden;
}
